export const useCookiebot = () => {
  onMounted(() => {
    window.Cookiebot?.runScripts()
  })
}
